import * as React from 'react';
import styles from './index.less';
import type { FPodcastRssSubmitOptionCardProps } from '../types';

function FPodcastRssSubmitOptionCard({
  className = '',
  style,
  children,
}: FPodcastRssSubmitOptionCardProps) {
  return (
    <div className={[styles.optionCard, className].join(' ')} style={style}>
      {children}
    </div>
  );
}

export default FPodcastRssSubmitOptionCard;
